module.exports = __webpack_public_path__ + "img/rg-bottom.3f4104c3.png";